import { getApiUrl, refreshAccessToken } from "./apiService";
import { tokenStore } from "./tokenStore";
import { createApiError } from "./apiError";
import { withApiLanguageHeader } from "./languageHeaders";

async function fetchMeRaw(token) {
  const res = await fetch(getApiUrl("api/Auth/me"), {
    method: "GET",
    credentials: "include",
    headers: withApiLanguageHeader(token ? { Authorization: `Bearer ${token}` } : {}),
  });

  if (!res.ok) throw await createApiError(res);
  return res.json();
}

export async function bootstrapAuth() {
  let token = tokenStore.get();

  if (token) {
    try {
      const me = await fetchMeRaw(token);
      return { authenticated: true, me };
    } catch (error) {
      if (error?.status !== 401 && error?.status !== 403) {
        // A temporary transport/server problem is not proof that the session ended.
        return { authenticated: true, me: null };
      }
    }
  }

  // sessionStorage may disappear with a closed/recreated mobile tab. Restore
  // from the HttpOnly cookie whether the old access token exists or not.
  try {
    token = await refreshAccessToken();
  } catch (error) {
    if (error?.sessionRejected) tokenStore.clear();
    return { authenticated: false, me: null };
  }

  try {
    const me = await fetchMeRaw(token);
    return { authenticated: true, me };
  } catch (error) {
    if (error?.status === 401 || error?.status === 403) {
      tokenStore.clear();
      return { authenticated: false, me: null };
    }
    return { authenticated: true, me: null };
  }
}
